<!-- Error Views -->
<app-module-error *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<!-- Content -->
<div class="gridItemChildModule h-100 d-flex flex-column" *ngIf="isFirstDataLoaded && !isNoMetric">
    <!-- Search CXOne -->
    <div *ngIf="this['configService'].isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
        <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
                          (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400">
        </cxone-text-input>
        <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
            <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
        </i>
        <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
            <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </i>
    </div>

    <!-- Ag Grid -->
    <div class="mintervalGridContainer flex-fill h-100" *ngIf="isFirstDataLoaded">
        <div class="intervalGridContainer flex-fill h-100" *ngIf="isGridReady">
            <ag-grid-angular #metricReviewWidgetGrid *ngIf="gridOptions !== null" class="ag-theme-balham flex-fill h-100" [gridOptions]="gridOptions"></ag-grid-angular>
        </div>
    </div>
</div>
